// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"4951b56c","64":"23a6dcf3","81":"73bfa0c8","146":"e48c7c0e","174":"f6148682","200":"af30c5b0","232":"123e610b","347":"259b95a4","421":"6ec95529","445":"163c658b","511":"e21d771d","538":"4dc10b00","544":"89613407","610":"b9711df7","746":"8cd36369","822":"bf1b9f86"}[chunkId] + ".chunk.js";
};